import { computed as i, createElementBlock as l, openBlock as m } from "vue";
import { startCase as u, camelCase as h } from "lodash-es";
import s from "../../icons/core-icons/index.js";
import { Unknown as g } from "../../icons/unknown.js";
import { UnknownCountries as w } from "../../icons/unknown-countries.js";
import { UnknownFinancial as d } from "../../icons/unknown-financial.js";
const p = ["width", "height", "viewBox", "aria-label", "innerHTML"], C = /* @__PURE__ */ Object.assign({
  name: "DsIconCore"
}, {
  __name: "icon-core",
  props: {
    name: {
      type: String,
      required: !0
    },
    category: {
      type: String,
      required: !0
    },
    ariaLabel: {
      type: String,
      default: ""
    }
  },
  setup(r) {
    const a = (n) => u(h(n)).replace(/ /g, ""), e = r, c = i(() => (console.warn(`The selected icon is not part of core icons - category: ${e.category}, name: ${e.name}`), e.category === "countries" ? w : e.category === "financial" ? d : g)), o = i(() => {
      var n;
      return s && ((n = s[a(e.category)]) == null ? void 0 : n[a(e.name)]) || c.value;
    }), t = i(() => ({ width: o.value.dimensions.width, height: o.value.dimensions.height }));
    return (n, f) => (m(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.value.width,
      height: t.value.height,
      viewBox: `0 0 ${t.value.width} ${t.value.height}`,
      "aria-label": r.ariaLabel || r.name,
      role: "img",
      class: "icon",
      innerHTML: o.value.content
    }, null, 8, p));
  }
});
export {
  C as default
};
